import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileText, Utensils, Activity, Moon, Brain } from 'lucide-react';
export function SolutionSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const features = [{
    icon: FileText,
    title: 'Protocolo Maestro Potencia 21 (PDF)',
    desc: 'El mapa exacto de 21 días dividido en tres fases (Reset, Carga y Blindaje).'
  }, {
    icon: Utensils,
    title: 'Guía de Nutrición de Combustible Masculino',
    desc: "La lista de compras 'Super-T' con los alimentos exactos que funcionan como precursores hormonales."
  }, {
    icon: Activity,
    title: 'Rutina de 12 Minutos de Flujo Sanguíneo',
    desc: 'Ejercicios específicos para mejorar la circulación pélvica sin pisar un gimnasio.'
  }, {
    icon: Moon,
    title: 'Protocolo de Sueño Profundo 7-9',
    desc: 'El método de optimización nocturna donde realmente se fabrica tu virilidad.'
  }, {
    icon: Brain,
    title: 'Técnica de Control y Resistencia',
    desc: 'Ejercicios de respiración para dominar la ansiedad de rendimiento y durar más.'
  }];
  return <section className="py-24 px-4 bg-[#0a0e1a] relative" data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        {/* The Unique Mechanism */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="mb-24" data-id="element-191">
          <motion.div variants={itemVariants} className="bg-[#111827] rounded-2xl p-8 md:p-12 border border-[#00d4ff]/30 box-glow-cyan relative overflow-hidden" data-id="element-192">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#00d4ff] opacity-5 blur-[80px] rounded-full pointer-events-none" data-id="element-193" />

            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6" data-id="element-194">
              <span className="text-[#00d4ff] text-glow-cyan" data-id="element-195">
                El Interruptor Bio-Hormonal.
              </span>
            </h2>

            <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-6" data-id="element-196">
              Potencia 21 no es un libro de consejos mediocres. Es un manual de
              ingeniería humana diseñado para manipular tu biología. Usamos un
              método de 3 fases para "engañar" a tu sistema nervioso, desplomar
              el cortisol y forzar a tu cuerpo a liberar la testosterona que ya
              tienes atrapada.
            </p>
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-197">
              No le pedimos permiso a tu cuerpo;{' '}
              <span className="text-[#00d4ff]" data-id="element-198">
                le damos las órdenes correctas.
              </span>
            </p>
          </motion.div>
        </motion.div>

        {/* What You Get */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-199">
          <motion.h3 variants={itemVariants} className="text-3xl font-bold text-center text-white uppercase tracking-tight mb-12" data-id="element-200">
            Lo que obtienes hoy
          </motion.h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-201">
            {features.map((feature, idx) => {
            const Icon = feature.icon;
            return <motion.div key={idx} variants={itemVariants} className={`bg-[#1a1f2e] p-8 rounded-xl border-t-4 border-[#00d4ff] shadow-lg hover:bg-[#1f2537] transition-colors ${idx === 0 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-202">
                  <div className="w-14 h-14 rounded-full bg-[#00d4ff]/10 flex items-center justify-center mb-6" data-id="element-203">
                    <Icon className="w-7 h-7 text-[#00d4ff]" data-id="element-204" />
                  </div>
                  <h4 className="text-xl font-bold text-white mb-3 leading-tight" data-id="element-205">
                    {feature.title}
                  </h4>
                  <p className="text-slate-400 leading-relaxed" data-id="element-206">
                    {feature.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}